/**
 * The audio library this BUILD ships — its manifest, compiled into the bundle by
 * `vite-plugin-audio-library.ts`, so this page can only ever ask for files its own deploy published
 * (plan §9.8: "a deploy never serves a page against another deploy's manifest").
 */
import { parseAudioManifest, voiceTrackLang, type AudioManifest } from '@dimensionscore/shared';
import { creditsUrl as builtCreditsUrl, libraryKind as builtKind, manifest as builtManifest } from 'virtual:dc-audio-library';

const parsed = parseAudioManifest(builtManifest);
if (parsed.problems.length > 0) console.warn(`audio library: ${parsed.problems.join('; ')}`);

export const LIBRARY: AudioManifest = parsed.manifest;

/** The full credits, published under a hashed name beside the tracks; null when the library has none. */
export const CREDITS_URL: string | null = builtCreditsUrl;

/** `dev` when this build carries the generated dev library rather than the real one. */
export const LIBRARY_KIND: 'library' | 'dev' | 'override' = builtKind;

/**
 * Every URL the page may ever play — what the service worker is told to keep. Voice clips count only
 * in `lang`, so a cache that once held another language's lines lets them go (§9.8).
 */
export function retainedUrls(manifest: AudioManifest, lang: string | null): string[] {
  const urls: string[] = [];
  for (const [id, entry] of Object.entries(manifest)) {
    const voice = voiceTrackLang(id);
    if (voice !== null && voice !== lang) continue;
    if (entry.ogg !== '') urls.push(entry.ogg);
    if (entry.mp3 !== '') urls.push(entry.mp3);
  }
  return urls;
}
